var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clientArea secPdng animated"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.partners),function(partner,index){return _c('div',{key:index,staticClass:"col-md-3 col-sm-4 col-xs-6"},[_c('div',{staticClass:"singleClient"},[_c('a',{attrs:{"href":partner.url,"target":"_blank"}},[_c('img',{attrs:{"src":partner.image_url,"alt":""}})])])])}))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65851c3f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/site/SitePartners.vue
// module id = null
// module chunks = 